import React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './ButtonLogIn.styles'
import { useHistory } from 'react-router-dom'
import LINKS from 'App.const'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(styles, { name: 'ButtonLogIn' })

function ButtonLogIn () {
  // eslint-disable-next-line no-unused-vars
  const classes = useStyles()
  const history = useHistory()

  const logIn = () => {
    const externalLoginPagePath = window.appSettings.externalLoginPagePath
    if (externalLoginPagePath) {
      window.location.replace(externalLoginPagePath)
    } else {
      history.push(LINKS.MAIN.AUTHORIZATION.path)
    }
  }

  return (
    <Button onClick={logIn}>
      <FormattedMessage id='log_in' defaultMessage='Log in' />
    </Button>
  )
}

export default ButtonLogIn
